<script lang="ts">
    import { melt } from '@melt-ui/svelte';
    import { cx } from '$lib/utils/cx';
    import { type MeltWithAction, meltWithActionDefault } from '$lib/utils/melt';

    export let variant: 'bg-light' | 'bg-dark' = 'bg-light';
    export let label: string;
    export let image: string;
    export let meltElement: MeltWithAction = meltWithActionDefault;
    export let href: string;
    export let svelteKitReload: boolean = true;
</script>

<a
    use:melt={meltElement}
    {href}
    class={cx(
        'flex flex-col items-center justify-center',
        'gap-y-[12px]',
        'px-[8px] py-[12px]',
        'max-w-[120px]',
        'no-underline hover:no-underline outline-0',
        'rounded-[8px]',
        'border-solid border border-transparent',
        ...(variant === 'bg-light'
            ? [
                  'hover:bg-gray-100 focus:bg-gray-100',
                  'hover:border-gray-350 focus:border-gray-350',
              ]
            : ['hover:bg-brand-blue focus:bg-brand-blue']),
    )}
    data-sveltekit-reload={svelteKitReload}
>
    <img src={image} alt={label} class="max-w-[78px] h-[48px] object-contain" />
    <span
        class={cx(
            variant === 'bg-light' ? 'text-gray-800' : 'text-white',
            'text-14/[16px]',
            'font-medium',
            'py-[8px]',
            'text-center',
        )}>{label}</span
    >
</a>
